import React, { useState, useEffect, useCallback } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";

import api from "../../services/api";
import toastError from "../../errors/toastError";

// Coaching de IA por atendente, sob demanda - admin abre, ve o ultimo
// gerado (se existir) e pode pedir um novo a qualquer momento. So'
// acessivel via botao que ja e' admin-only (ver TableAttendantsStatus.js).
const AttendantCoachingModal = ({ open, onClose, attendant }) => {
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [latest, setLatest] = useState(null);

  const fetchLatest = useCallback(async () => {
    if (!attendant) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/attendant-coaching/${attendant.id}`);
      setLatest(data && data.length > 0 ? data[0] : null);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  }, [attendant]);

  useEffect(() => {
    if (open) {
      fetchLatest();
    } else {
      setLatest(null);
    }
  }, [open, fetchLatest]);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      const { data } = await api.post(`/attendant-coaching/${attendant.id}`);
      setLatest(data);
    } catch (err) {
      toastError(err);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Coaching de IA — {attendant?.name}</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
            <CircularProgress size={28} />
          </div>
        )}

        {!loading && latest && (
          <>
            <Typography variant="caption" color="textSecondary">
              Gerado em {moment(latest.createdAt).format("DD/MM/YYYY HH:mm")} · período{" "}
              {moment(latest.periodStart).format("DD/MM")} a{" "}
              {moment(latest.periodEnd).format("DD/MM")} · {latest.ticketCount} atendimentos
              analisados
            </Typography>
            <Typography variant="body1" style={{ marginTop: 12, whiteSpace: "pre-wrap" }}>
              {latest.content}
            </Typography>
          </>
        )}

        {!loading && !latest && (
          <Typography variant="body2" color="textSecondary">
            Nenhum coaching gerado ainda pra este atendente. Clique em "Gerar coaching" pra
            criar um com base nos últimos 30 dias de atendimentos.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Fechar
        </Button>
        <Button
          onClick={handleGenerate}
          color="primary"
          variant="contained"
          disabled={generating || loading}
        >
          {generating ? <CircularProgress size={18} /> : "Gerar novo coaching"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttendantCoachingModal;
